// extracted by mini-css-extract-plugin
export default {"container":"EZ-z","heading":"FZ-z","links":"GZ-z","copy":"HZ-z","subCopy":"IZ-z","linksLeft":"JZ-z","linksCenter":"KZ-z","linksRight":"LZ-z","link":"MZ-z","onlyLink":"NZ-z"};